var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getShowIcon)?_c('div',{attrs:{"data-component":"suit-symbol"}},[_c('icon',{attrs:{"icon":_vm.getIcon,"colour":_vm.getColour}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }